import React from 'react';
import { AddressPropTypes } from './AddressPropTypes';
import { Flex, Link, Text } from '@chakra-ui/react';
import { Icon } from '../icon';
import { flexBoxStyles } from './constant';
import { CTAButtons } from './CTAButtons';
import { phoneNumberFormat } from '../../utils/constant';

export const ContactDetails = ({
  isContactCard,
  locationContactDetails,
  locationName,
  buttonConfig,
}: AddressPropTypes.ILocation) => {
  const getIcon = (type: string) => {
    const data = type.toLocaleLowerCase();
    if (data.includes('address')) {
      return 'icon-tfw-location';
    } else if (data.includes('email')) {
      return 'icon-tfw-email';
    } else if (data.includes('phone')) {
      return 'icon-tfw-call';
    } else {
      return '';
    }
  };

  const ContactCard = () => {
    return (
      <Flex
        width={{ base: 'auto', sm: '649px' }}
        {...flexBoxStyles}
        p={'32px 16px'}
        backgroundColor={'button.blue'}
        color={'common.gWhite'}
      >
        <Text textStyle={'h3'}>{locationName}</Text>
        <>
          {!!locationContactDetails?.length &&
            locationContactDetails.map(({ data, redirect, type }, index) => {
              if (type.toLocaleLowerCase().includes('phone')) {
                data = phoneNumberFormat(data);
              }
              return (
                <Link
                  href={redirect}
                  color={'common.gWhite'}
                  key={index}
                  display={'inline'}
                  textTransform={'capitalize'}
                  isExternal
                >
                  <Icon size="small" className={getIcon(type)} /> {data}
                </Link>
              );
            })}
        </>
      </Flex>
    );
  };

  const NormalContact = () => {
    return (
      <Flex
        {...flexBoxStyles}
        gap={'16px'}
        p={{ base: '0px', sm: '0px 24px 0px 16px' }}
        borderRight={{ sm: '1px solid grey' }}
        borderColor={'border.grey'}
      >
        <>
          <Text textStyle={'h3'}>{locationName}</Text>
          {!!locationContactDetails?.length &&
            locationContactDetails.map(({ type, data, redirect }, index) => {
              if (type.toLocaleLowerCase().includes('phone')) {
                data = phoneNumberFormat(data);
              }
              return (
                <>
                  <Text key={index} textTransform={'capitalize'}>
                    <b>{type} : </b>
                    <Link href={redirect} isExternal>
                      {data}
                    </Link>
                  </Text>
                </>
              );
            })}
          <CTAButtons ctaButtonConfig={buttonConfig} />
        </>
      </Flex>
    );
  };

  return isContactCard ? <ContactCard /> : <NormalContact />;
};
